import { BaseType } from '../base/base-type';
import { ConsentWaiverTypeEnum } from './consent-waiver-type.enum';

export class ConsentWaiverType extends BaseType {
  public declare id: ConsentWaiverTypeEnum;
}
